import type { RydeAdminUnit } from "../models/common.models";

export const BACKUP_ENTITY: RydeAdminUnit = "backup";

/** `runBy` value the backend stamps on a scheduled run; anything else is the username that ran it. */
export const BACKUP_RUN_BY_CRON = "cron";

/**
 * Value of the "Global" entry in the drawer's company multi-select. A string among numeric company ids,
 * so splitting the selection back into companies + the global scope needs no extra state.
 */
export const BACKUP_GLOBAL_SCOPE_VALUE = "global";

// Matches the summary log the backend writes when an on-demand backup completes:
// "Backup complete: {n} of {n} entity dumps across {n} scope(s)".
export const BACKUP_CREATE_SUMMARY_PATTERN =
  /(\d+) of (\d+) entity dumps across (\d+) scope/;

// Matches the summary log the backend writes when a restore process completes:
// "Restore complete: {n} inserted, {n} updated, {n} deleted, {n} skipped".
export const RESTORE_SUMMARY_PATTERN =
  /(\d+) inserted, (\d+) updated, (\d+) deleted, (\d+) skipped/;
